import React, {useState, useEffect} from 'react';
import './styles.scss';

const Counter: React.FC<{date: string}> = ({date}) => {
  const calculateTimeLeft = () => {
    const difference = +new Date(date ? date : 'Jan 28 2022 08:00:00 GMT') - +new Date(new Date().toUTCString());
    let timeLeft = {};

    if (difference > 0) {
      timeLeft = {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / 1000 / 60) % 60),
        seconds: Math.floor((difference / 1000) % 60),
      };
    }

    return timeLeft;
  };

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  useEffect(() => {
    setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);
  }, []);

  return (
    <>
      {//@ts-ignore
      timeLeft && (timeLeft.days || timeLeft.hours || timeLeft.minutes || timeLeft.seconds) ? (
        <div className="countdown_container m-auto">
          <div className="unit">
            <div className="number_container">
              {
                //@ts-ignore
                timeLeft.days
              }
            </div>
            <div className="label_container">Days</div>
          </div>
          <div className="unit">
            <div className="number_container">
              {
                //@ts-ignore
                timeLeft.hours
              }
            </div>
            <div className="label_container">Hours</div>
          </div>
          <div className="unit">
            <div className="number_container">
              {
                //@ts-ignore
                timeLeft.minutes
              }
            </div>
            <div className="label_container">Minutes</div>
          </div>
          <div className="unit">
            <div className="number_container">
              {
                //@ts-ignore
                timeLeft.seconds
              }
            </div>
            <div className="label_container">Seconds</div>
          </div>
        </div>
      ) : null}
    </>
  );
};

export default Counter;
